var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",attrs:{"title":_vm.$t('logoTitle')},on:{"click":_vm.clickHandler}},[_c('logo-image',{style:({width: _vm.width, height: _vm.height, color: _vm.color})})],1)}
var staticRenderFns = []

export { render, staticRenderFns }